import { DEFAULT_LANGUAGE, Language, SUPPORTED_LANGUAGES } from 'constants/languages';

// Publication titles, citations, conference references, and official course names
// retain their source language so the academic record remains accurate.

export const turkish = {
  'Main navigation': 'Ana menü',
  Menu: 'Menü',
  'Close menu': 'Menüyü kapat',
  'Back to home': 'Ana sayfaya dön',
  'Page not found': 'Sayfa bulunamadı',
  'Patient recommendations': 'Hastalara Öneriler',
  'PATIENT INFORMATION & ACADEMIC PROFILE': 'HASTA BİLGİLENDİRME VE AKADEMİK PROFİL',
  'PATIENTS & RESEARCH': 'HASTALAR VE ARAŞTIRMA',
  'FOR PATIENTS': 'HASTALAR İÇİN',
  'Academic profile': 'Akademik profil',
  'Patient information and academic work in endocrinology and metabolic diseases, together in one place.':
    'Endokrinoloji ve metabolizma hastalıkları alanında hasta bilgilendirme notları ve akademik çalışmalar bir arada.',
  'Practical information, easy to find.': 'Bilgilendirme notları elinizin altında.',
  'Browse notes by topic and save a link for later.':
    'Notları konuya göre keşfedin, bağlantılarını daha sonra okumak için kaydedin.',
  'Clinical experience & research.': 'Klinik deneyim ve araştırma.',
  'Explore qualifications, publications, and scientific contributions.':
    'Eğitim, yayınlar ve bilimsel katkıları inceleyin.',
  'GET TO KNOW YOUR DOCTOR': 'HEKİMİNİZİ TANIYIN',
  'Clinical training, research, and professional development.':
    'Klinik eğitim, araştırma ve mesleki gelişim.',
  Overview: 'Genel bakış',
  Experience: 'Deneyim',
  Publications: 'Yayınlar',
  Presentations: 'Sunumlar',
  'Professional development': 'Mesleki gelişim',
  'Affiliations & languages': 'Üyelikler ve diller',
  'Skip to content': 'İçeriğe geç',
  'Rıza Gökhan Baykal home': 'Rıza Gökhan Baykal ana sayfa',
  'ACADEMIC PROFILE': 'AKADEMİK PROFİL',
  'Share profile': 'Profili paylaş',
  'Download CV': 'Özgeçmişi indir',
  'Profile link copied to clipboard': 'Profil bağlantısı panoya kopyalandı',
  'Copy this profile link': 'Bu profil bağlantısını kopyalayın',
  Close: 'Kapat',
  'Doctor emblem': 'Hekim amblemi',
  'Profile sections': 'Profil bölümleri',
  'Endocrinology &': 'Endokrinoloji ve',
  'Metabolic Diseases': 'Metabolizma Hastalıkları',
  'CLINICAL PRACTICE.': 'KLİNİK UYGULAMA.',
  'ACADEMIC INQUIRY.': 'AKADEMİK ARAŞTIRMA.',
  'PHYSICIAN & RESEARCHER': 'HEKİM VE ARAŞTIRMACI',
  'CURRICULUM VITAE': 'ÖZGEÇMİŞ',
  'Endocrinology & Metabolic Diseases': 'Endokrinoloji ve Metabolizma Hastalıkları',
  'A clinical and academic focus on endocrine disorders, metabolic health, and the role of data in advancing medical research.':
    'Endokrin hastalıklar, metabolik sağlık ve tıbbi araştırmalarda verinin rolüne odaklanan klinik ve akademik çalışmalar.',
  'CURRENT APPOINTMENT': 'GÜNCEL GÖREV',
  'Specialist in Endocrinology & Metabolic Diseases':
    'Endokrinoloji ve Metabolizma Hastalıkları Uzmanı',
  'Mardin Training and Research Hospital · Türkiye':
    'Mardin Eğitim ve Araştırma Hastanesi · Türkiye',
  'Explore publications': 'Yayınları incele',
  'View experience': 'Deneyimi görüntüle',
  'Publication entries': 'Yayın kaydı',
  'Conference presentations': 'Kongre sunumları',
  'Medical degree awarded': 'Tıp fakültesi mezuniyeti',
  'RESEARCH THEMES': 'ARAŞTIRMA ALANLARI',
  'Thyroid disorders': 'Tiroid hastalıkları',
  'Adrenal disease': 'Adrenal hastalıklar',
  'Obesity & metabolism': 'Obezite ve metabolizma',
  'Endocrine disruptors': 'Endokrin bozucular',
  'CLINICAL & ACADEMIC PATH': 'KLİNİK VE AKADEMİK KARİYER',
  'Experience & education': 'Deneyim ve eğitim',
  CURRENT: 'GÜNCEL',
  '2026 — Present': '2026 — Günümüz',
  'Mardin Training and Research Hospital': 'Mardin Eğitim ve Araştırma Hastanesi',
  'Ankara Bilkent City Hospital': 'Ankara Bilkent Şehir Hastanesi',
  'Specialist in Internal Medicine': 'İç Hastalıkları Uzmanı',
  'Hüyük State Hospital': 'Hüyük Devlet Hastanesi',
  'Research Assistant · Internal Medicine': 'Araştırma Görevlisi · İç Hastalıkları',
  'Hacettepe University Faculty of Medicine': 'Hacettepe Üniversitesi Tıp Fakültesi',
  'Research Assistant · Pediatrics': 'Araştırma Görevlisi · Çocuk Sağlığı ve Hastalıkları',
  'Ankara University Faculty of Medicine': 'Ankara Üniversitesi Tıp Fakültesi',
  EDUCATION: 'EĞİTİM',
  'Doctor of Medicine': 'Tıp Eğitimi',
  'Ankara University Faculty of Medicine, Türkiye': 'Ankara Üniversitesi Tıp Fakültesi, Türkiye',
  'GPA: 3.44 / 4.00': 'Mezuniyet notu: 3,44 / 4,00',
  'RESEARCH & SCHOLARSHIP': 'ARAŞTIRMA VE AKADEMİK ÇALIŞMALAR',
  '15 entries': '15 kayıt',
  'Search publications': 'Yayınlarda ara',
  'Search by title, author, or keyword…': 'Başlık, yazar veya anahtar kelimeyle ara…',
  'Publication year': 'Yayın yılı',
  'All years': 'Tüm yıllar',
  'Filter publication type': 'Yayın türüne göre filtrele',
  'All publications': 'Tüm yayınlar',
  'Journal articles': 'Dergi makaleleri',
  'Conference abstracts': 'Kongre özetleri',
  'Journal article': 'Dergi makalesi',
  'Conference abstract': 'Kongre özeti',
  'Full citation': 'Tam kaynakça',
  'No publications found': 'Yayın bulunamadı',
  'Try another keyword, year, or publication type.':
    'Başka bir anahtar kelime, yıl veya yayın türü deneyin.',
  'Clear filters': 'Filtreleri temizle',
  'Show fewer publications': 'Daha az yayın göster',
  'BOOK CHAPTER · 2023': 'KİTAP BÖLÜMÜ · 2023',
  'SCIENTIFIC EXCHANGE': 'BİLİMSEL PAYLAŞIM',
  '29 presentations': '29 sunum',
  'Contributions to European and national endocrinology congresses, including ECE, the Joint Congress of ESPE and ESE, EndoBridge, and TEMD.':
    'ECE, ESPE ve ESE Ortak Kongresi, EndoBridge ve TEMD dahil olmak üzere uluslararası ve ulusal endokrinoloji kongrelerine katkılar.',
  'International poster presentations': 'Uluslararası poster sunumları',
  'International oral presentation': 'Uluslararası sözlü sunum',
  'National oral presentations': 'Ulusal sözlü sunumlar',
  'National poster presentations': 'Ulusal poster sunumları',
  'CONTINUING EDUCATION': 'SÜREKLİ EĞİTİM',
  'Data science & programming': 'Veri bilimi ve programlama',
  Endocrinology: 'Endokrinoloji',
  Biostatistics: 'Biyoistatistik',
  'Endocrine Society · Non-board education':
    'Endocrine Society · Uzmanlık belgesi niteliği taşımayan eğitimler',
  'Endocrine Board Review 2023 Bundle · Completed December 2024; 55 AMA PRA Category 1 Credits™; practice exam 93% (non-board)':
    'Endocrine Board Review 2023 Bundle · Aralık 2024’te tamamlandı; 55 AMA PRA Category 1 Credits™; deneme sınavı %93 (uzmanlık belgesi değildir)',
  'Update in Primary Aldosteronism · January 2025': 'Update in Primary Aldosteronism · Ocak 2025',
  'Artificial Intelligence in Endocrine Diseases · November 2024':
    'Artificial Intelligence in Endocrine Diseases · Kasım 2024',
  'Basic Biostatistics Course for Health Research · Prof. Dr. Mutlu Hayran, Hacettepe University, 2017':
    'Sağlık Araştırmaları İçin Temel Biyoistatistik Kursu · Prof. Dr. Mutlu Hayran, Hacettepe Üniversitesi, 2017',
  'SELECTED PYTHON PROJECT': 'SEÇİLİ PYTHON PROJESİ',
  'Endocrine time-series analysis': 'Endokrin zaman serisi analizi',
  'A reproducible workflow for feature extraction and visualization using synthetic, wearable-style signals.':
    'Giyilebilir cihaz sinyallerini örnekleyen sentetik verilerle özellik çıkarımı ve görselleştirme için tekrarlanabilir bir çalışma akışı.',
  'ACADEMIC SERVICE': 'AKADEMİK HAKEMLİK',
  'Peer-review contributions:': 'Hakemlik katkıları:',
  '8 reviews': '8 hakemlik',
  'across 4 publications/grants, as reported in the CV’s ORCID record.':
    '· Özgeçmişteki ORCID kaydına göre 4 yayın/hibe kapsamında.',
  'PROFESSIONAL COMMUNITY': 'MESLEKİ TOPLULUK',
  'Society memberships': 'Dernek üyelikleri',
  'Society of Endocrinology and Metabolism of Türkiye':
    'Türkiye Endokrinoloji ve Metabolizma Derneği',
  'TEMD · Since 2024': 'TEMD · 2024’ten beri',
  'European Society of Endocrinology': 'Avrupa Endokrinoloji Derneği (ESE)',
  'ESE · Since 2024': 'ESE · 2024’ten beri',
  'Since 2024': '2024’ten beri',
  'TOS · Since 2025': 'TOS · 2025’ten beri',
  'Languages & assessments': 'Yabancı diller ve sınavlar',
  English: 'İngilizce',
  Swedish: 'İsveççe',
  French: 'Fransızca',
  German: 'Almanca',
  'IELTS Academic 6.5 · January 2026': 'IELTS Academic 6,5 · Ocak 2026',
  'YDS 81.25 · November 2025': 'YDS 81,25 · Kasım 2025',
  'B2 · February 2026': 'B2 · Şubat 2026',
  'Swedish, French, and German levels are based on Folkuniversitetet online test certificates.':
    'İsveççe, Fransızca ve Almanca seviyeleri Folkuniversitetet çevrim içi sınav sertifikalarına dayanmaktadır.',
  'THE COMPLETE ACADEMIC RECORD': 'TÜM AKADEMİK GEÇMİŞ',
  'Take the CV with you.': 'Özgeçmişi yanınıza alın.',
  'Download the original curriculum vitae for your records.':
    'Özgün özgeçmişi arşiviniz için indirin.',
  'Download curriculum vitae': 'Özgeçmişi indir',
  'Back to top ↑': 'Başa dön ↑',
};

export const initialLanguage = () => {
  const linkedLanguage = new URLSearchParams(window.location.search).get('lang');

  if (SUPPORTED_LANGUAGES.includes(linkedLanguage)) {
    return linkedLanguage;
  }

  try {
    const storedLanguage = localStorage.getItem('cv-language');

    return SUPPORTED_LANGUAGES.includes(storedLanguage) ? storedLanguage : DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
};

export const translate = (language, text) => {
  return language === Language.TURKISH ? (turkish[text] ?? text) : text;
};
